export const ACCEPTED = 'accepted'
export const DECLINED = 'declined'
export const EXPIRED = 'expired'
export const PENDING_PRO_MEMBER = 'pending_pro_member'
export const PENDING_LIMITED_MEMBER = 'pending_limited_member'
export const PRE_ACCEPTED = 'pre-accepted'
